
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { VipModifyService } from '@/views/dashboard/_notify-popup/vip-modify/vip-modify.service'
import { NotifyPopupService, PopupKey } from '@/views/dashboard/_notify-popup/notify-popup.service'
import { router } from '@/router'
import Cookies from 'js-cookie'

export default defineComponent({
  setup (props, context) {
    const injector = useReflectiveInjector([VipModifyService])
    const notifyPopupService = injector.get(NotifyPopupService)
    const vipModifyService = injector.get(VipModifyService)

    const visible = ref(false)

    const notifyPopupSubscribe = notifyPopupService.onChangeActiveIndex.subscribe(() => {
      const popupKey = notifyPopupService.activePopupKey
      if (popupKey !== PopupKey.vipModify) {
        return
      }

      const teamInfo = JSON.parse(Cookies.get('currentTeam') || '{}')
      if (teamInfo.show_vip_modify) {
        visible.value = true
      } else {
        notifyPopupService.nextPopup()
      }
    })

    onMounted(() => {
      notifyPopupService.popupToReady(PopupKey.vipModify)
    })

    function doKnow () {
      vipModifyService.updateShowVip()
      visible.value = false
      notifyPopupService.nextPopup()
    }

    function toMyService () {
      vipModifyService.updateShowVip()
      visible.value = false
      notifyPopupService.closeAllPopup()
      router.push('/dashboard/service-subscribe')
    }

    onUnmounted(() => {
      notifyPopupSubscribe.unsubscribe()
    })

    return {
      visible,
      doKnow,
      toMyService,
    }
  }
})
